import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { CardBlank } from '@/shared/ui/CardBlank';
import { advantagesModel } from '@/widgets/HomePage/Advantages/model';

const Advantages = () => (
  <section className={cn('section', styles.advantages)}>
    <div className="container">
      <h2>
        <FormattedMessage defaultMessage="Почему именно мы?" />
      </h2>
      <h3 className={styles.subtitle}>
        <FormattedMessage defaultMessage="Наши преимущества" />
      </h3>
      <div className={styles.mainBlock}>
        {advantagesModel.map((row, index) => (
          <div key={index} className={styles.row}>
            {row.map(({ message, Image }, index) => (
              <CardBlank key={index} className={styles.card}>
                <div className={styles.imageWrapper}>
                  <Image />
                </div>
                <h4 className={styles.text}>{message}</h4>
              </CardBlank>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Advantages;
